import type { CandidateVacancy } from '../types';

type CandidateProfile = NonNullable<
  CandidateVacancy['responsibleUser']
>['profile'];

export function mockCandidateProfile(
  overrides: Partial<CandidateProfile> = {}
): CandidateProfile {
  return {
    id: 1,
    firstName: 'Jane',
    lastName: 'Smith',
    phone: '+33111111111',
    position: 'Recruitment manager',
    ...overrides,
  };
}
